import i18n from './i18nHelpers'

export default {
  getFullAddress (userPlace) {
    let fullAddress = userPlace.address
    const addressProvince = userPlace.address_province
    const district = userPlace.district
    const subDistrict = userPlace.sub_district
    if (addressProvince) {
      fullAddress += ' '
      fullAddress += i18n.locale === 'th' ? addressProvince.name_th : addressProvince.name_en
    }
    if (district) {
      fullAddress += ' '
      fullAddress += i18n.locale === 'th' ? district.name_th : district.name_en
    }
    if (subDistrict) {
      fullAddress += ' '
      fullAddress += i18n.locale === 'th' ? subDistrict.name_th : subDistrict.name_en
      fullAddress += ' ' + subDistrict.zip_code
    }
    return fullAddress
  },
  calculateDistance (lat1, lon1, lat2, lon2) {
    const R = 6371
    const toRad = (value) => (value * Math.PI) / 180
    const dLat = toRad(lat2 - lat1)
    const dLon = toRad(lon2 - lon1)
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2)
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    const distance = R * c
    return distance
  }
}



// WEBPACK FOOTER //
// ./src/helpers/userPlaceHelpers.js